import { isDesktop } from "~/js/templates/index/helpers";

const ICON_DICTIONARY = {
  特集から探す: "star-outline-bold",
  コーディネートから探す: "book",
  オススメ商品一覧: "thumbup",
  新着商品一覧: "megaphone",
  発売予定商品一覧: "comming-soon",
  アウトレット商品一覧: "sale",
  ギフト検索: "present",
  店舗検索: "shop",
  すべてのクチコミを見る: "bubbles",
  お知らせ: "circle-i",
  ヘルプ: "circle-question",
};

const getMenuItemsDesktop = ({ categoryItems, menuItems }) => {
  return [
    [
      {
        title: "カテゴリから探す",
        iconName: "icon-sofa",
        items: categoryItems,
      },
    ],
    [...menuItems.slice(0, 3)],
    [...menuItems.slice(3)],
  ];
};

const getMenuItemsMobile = ({ categoryItems, menuItems, menuBottomItems }) => {
  return [
    [
      {
        title: "カテゴリから探す",
        iconName: "icon-sofa",
        items: categoryItems,
      },
      ...menuItems.map((item) => {
        if (item.items.length === 1 && !item.items[0].items.length) {
          return { ...item, url: item.items[0].url, items: [] };
        }
        return item;
      }),
    ],
    menuBottomItems,
  ];
};

export const getMenuItems = (element) => {
  const dataString = element.dataset.menuData;
  try {
    const dataJson = JSON.parse(dataString);
    const result = {};
    result.categoryItems = dataJson["header-categories"];
    result.menuItems = dataJson["header-menu"];
    result.menuBottomItems = dataJson["header-bottom-menu"];
    ["menuItems", "menuBottomItems"].forEach((key) => {
      result[key].forEach((item) => {
        item.iconName = `icon-${ICON_DICTIONARY[item.handle]}` || undefined;
      });
    });
    return isDesktop() ? getMenuItemsDesktop(result) : getMenuItemsMobile(result);
  } catch (error) {
    console.error(error);
  }
};
